/**
 * Thin client for tic_tac_toe_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'tic_tac_toe';

export const TTT_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.tic_tac_toe?.API_BASE || '')
    : '/ttt';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `TTT GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createTttSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${TTT_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveTttSession(sessionId, { row, col, player } = {}) {
    const res = await fetch(`${TTT_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ row, col, player }),
    });
    return parseJson(res);
}

export async function deleteTttSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${TTT_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const MOVE_POINTS = 100;
export const THREAT_BONUS = 40;
export const WIN_BONUS = 500;
export const DRAW_BONUS = 200;
